import { Navigation } from "./navigation.types";

export const fittNavigation: Navigation = {
    default: [
        {
            id: "conf",
            title: "Configuratore",
            type: "basic",
            icon: "heroicons_outline:folder",
            link: "/dashboard"
        }
    ],
    compact: [],
    futuristic: [],
    horizontal: []
};
